jQuery(document).ready(function($) {
	$(".cart_note-tab label").click(function(e) {
		var handle = "#" + $(this).attr("for");

		$(this).toggleClass("active");
		$(handle).toggleClass("hide");

		if (!$(this).hasClass("active")) {
			$(handle).val("");
		}
	});

	$("[data-modal-open]").click(function(e) {
		var modal_handle = $(this).attr("data-modal-open");

		$(".modal-container[data-modal='" + modal_handle + "']").addClass("is-active");
	});

	$(".modal__close").click(function(e) {
		$(this).parents(".modal-container").removeClass("is-active");
	});

	$(".modal-container").click(function(e) {
		$(this).removeClass("is-active");
	});

	$(".modal-container .modal").click(function(e) {
		e.stopPropagation();
	});

/*
	function updateLineItem_for_Bundle(el, url = null) {
		var qty = parseInt(el.val());
		var old_qty = parseInt(el.attr("data-qty"));

		var qty_off = qty - old_qty;
		console.log(qty_off);

		var cart_item = el.parents(".cart__item");
		var id_array = cart_item.attr("data-children").split("|");

		jQuery.ajax({
          type: 'POST',
          url: '/cart.js',
          dataType: 'json',
          success: function(cart) {
			console.log(id_array);

			var line_items = $(".cart__item");
			var updates = {};
			var id_qty = [];
			var ids = [];

			for(var i = 0; i < cart.items.length; i ++ ) {
				var t = {};
				t.id = cart.items[i].id;
				t.qty = cart.items[i].quantity;
				id_qty.push(t);
			}

			for(i = 0; i < id_array.length; i ++) {
				for( var j = 0; j < line_items.length; j ++ ) {
					var it = line_items.eq(j);
					var qty = it.find(".js-qty__num").val();

					if (id_array[i] == it.attr("data-id")) {

						if ($.inArray(id_array[i], ids) >= 0) {
							updates[id_array[i]] = parseInt(updates[id_array[i]]) + qty_off;
						}
						else {
							ids.push(id_array[i]);
							updates[id_array[i]] = parseInt(qty) + qty_off;
						}
					}
				}
			}
		  }
		});

		jQuery.ajax({
          type: 'POST',
          url: '/cart/update.js',
          data: {updates : updates},
          dataType: 'json',
          success: function(cart) {
          	if(url == null) {
	          	location.reload();
	        }
	        else {
	        	window.location.href = url;
	        }
          }
        });

		console.log(updates);
	}  
	*/

	function updateLineItem_Related(el, url = null) {
		var qty = parseInt(el.val());
		var old_qty = parseInt(el.attr("data-qty"));
		var qty_off = qty - old_qty;
		console.log(qty_off);

		var cart_item = el.parents(".cart__item");
		var id_array = cart_item.attr("data-children").split("|");

		console.log(id_array);

		var line_items = $(".cart__item");
		var updates = {};
		var ids = [];

		for(i = 0; i < id_array.length; i ++) {
			for( var j = 0; j < line_items.length; j ++ ) {
				var it = line_items.eq(j);
				var qty = parseInt(it.find(".js-qty__num").val());

				if (id_array[i] == it.attr("data-id")) {
					if ($.inArray(id_array[i], ids) >= 0) {
						updates[id_array[i]] = parseInt(updates[id_array[i]]) + qty_off;
					}
					else {
						ids.push(id_array[i]);
						updates[id_array[i]] = qty + qty_off;
					}
				}
			}
		}

		jQuery.ajax({
          type: 'POST',
          url: '/cart/update.js',
          data: {updates : updates},
          dataType: 'json',
          success: function(cart) {
          	if(url == null) {
	          	location.reload();
	        }
	        else {
	        	window.location.href = url;
	        }
          }
        });
	}

	$(".cart__item .js-qty__num").change(function(e) {
		if ($(this).parents(".cart__item").attr("data-children").trim() == null || $(this).parents(".cart__item").attr("data-children").trim() == '') {
			return;
		}

		var obj = $(this);
		setTimeout(function() { 
			updateLineItem_Related(obj);
		}, 500);
	});

	$(".cart__item .js-qty__adjust").click(function(e) {
		if ($(this).parents(".cart__item").attr("data-children").trim() == null || $(this).parents(".cart__item").attr("data-children").trim() == '') {
			return;
		}

		var obj = $(this);
		setTimeout(function() { 
			updateLineItem_Related(obj.parents(".cart__item").find(".js-qty__num")); 
		}, 500);
	});

	$(".cart__item .cart__remove a").click(function(e) {
		if ($(this).parents(".cart__item").attr("data-children").trim() == null || $(this).parents(".cart__item").attr("data-children").trim() == '') {
			return;
		}

		console.log("aaaaaaa");
		e.preventDefault();

		var url = $(this).attr("href");
		var qty_inp = $(this).parents(".cart__item").find(".js-qty__num");

		qty_inp.val("0");
		setTimeout(function() { 
			updateLineItem_Related(qty_inp, url);
		}, 500);
	});
});